import React from "react";
import { __ } from "@wordpress/i18n";

/**
 * React component rendering the Chinese zodiac calculator form on the front-end.
 * Reads the color theme from a hidden DOM input set by the block's save output.
 * @returns {JSX.Element} The form allowing the user to select their birth date.
 */
export default function ChineseZodiacCalculator() {
	// Retrieve the color theme saved as a hidden input in the block's HTML output
	const getThemeColor = document.getElementById('getThemeColor').value;

	// Calculate the range of selectable years: from 1924 up to the current year
	const currentYear = new Date().getFullYear();
	const yearLength = currentYear - 1924;

	// Build the year options array (most recent year first)
	const yearOptions = Array.from({ length: yearLength + 1 }, (_, index) => ({
		label: (currentYear - index).toString(),
		value: (currentYear - index).toString().padStart(2, '0'),
	}));

	// Build the month options array (01 to 12, zero-padded)
	const monthOptions = Array.from({ length: 12 }, (_, index) => ({
		label: (index + 1).toString().padStart(2, '0'),
		value: (index + 1).toString().padStart(2, '0'),
	}));

	// Build the day options array (01 to 31, zero-padded)
	const dayOptions = Array.from({ length: 31 }, (_, index) => ({
		label: (index + 1).toString().padStart(2, '0'),
		value: (index + 1).toString().padStart(2, '0'),
	}));

	return (
		<>
			{/* Apply the color theme class from the block settings */}
			<div id={"chinese-zodiac-form"} className={getThemeColor}>
				<p className={"form-title"}>{__("Calculez votre signe astrologique chinois", "superprof-gutenberg-blocks")}</p>
				<p className={"form-subtitle"}>{__("Entrez votre date de naissance et découvrez votre signe chinois.", "superprof-gutenberg-blocks")}</p>
				<form id={"chinese-astrology-calculator-form"}>
					<div className={"form-inner"}>
						<p id={"dateOfBirth"}>{__("Date de naissance :", "superprof-gutenberg-blocks")}</p>
						<div id={"form-inputs"}>
							{/* Birth year select (from 1924 to current year) */}
							<div className={"form-input"}>
								<label htmlFor="birthYear">{__("Année", "superprof-gutenberg-blocks")}</label>
								<select
									id="birthYear"
								>
									{yearOptions.map((option) => (
										<option key={option.value} value={option.value}>
											{option.label}
										</option>
									))}
								</select>
							</div>
							{/* Birth month select (01 to 12) */}
							<div className={"form-input"}>
								<label htmlFor="birthMonth">{__("Mois", "superprof-gutenberg-blocks")}</label>
								<select
									id="birthMonth"
								>
									{monthOptions.map((option) => (
										<option key={option.value} value={option.value}>
											{option.label}
										</option>
									))}
								</select>
							</div>
							{/* Birth day select (01 to 31) */}
							<div className={"form-input"}>
								<label htmlFor="birthDay">{__("Jour", "superprof-gutenberg-blocks")}</label>
								<select
									id="birthDay"
								>
									{dayOptions.map((option) => (
										<option key={option.value} value={option.value}>
											{option.label}
										</option>
									))}
								</select>
							</div>
						</div>
						<button className={"form-submit"} type="submit">{__("Calculer", "superprof-gutenberg-blocks")}</button>
					</div>
				</form>
			</div>
		</>
	)
}
